import { toast } from "sonner";

const toastCache = new Map<string, number>();
const TOAST_DEDUPLICATION_DELAY = 1000; // millisecondi

export function safeToastSuccess(message: string, options?: { description?: string }) {
  if (shouldShowToast(message, { description: options?.description ?? "" })) {
    toast.success(message, {
      description: options?.description,
    });
  }
}

export function safeToastError(message: string, options?: { description?: string }) {
  if (shouldShowToast(message, { description: options?.description ?? "" })) {
    toast.error(message, {
      description: options?.description,
    });
  }
}

export function safeToastInfo(message: string, options?: { description?: string }) {
  if (shouldShowToast(message, {
      description: options?.description,
    })) {
    toast(message);
  }
}

function shouldShowToast(message: string, p0: { description: string; }): boolean {
  const now = Date.now();
  const lastShown = toastCache.get(message) || 0;

  if (now - lastShown > TOAST_DEDUPLICATION_DELAY) {
    toastCache.set(message, now);
    return true;
  }

  return false;
}
